import type { Ref } from 'vue';
import { computed } from 'vue';

import {
  useFileAiReviewsQuery as useQuery,
  type FileAiReviewFragmentFragment,
  type FileAiReviewsQueryVariables,
} from '@/graphql/generated/graphql';
import useTableSearchOrder from '@/ui/Table/useTableRouter/seachOrder/useTableSearchOrder';

const useFileAiReviewsSearch = (
  fileId: Ref<number>,
  setURL?: boolean,
) => {
  const {
    query, setQuery, search, setSearch,
  } = useTableSearchOrder<keyof FileAiReviewFragmentFragment, Record<string, never>>(setURL);

  const variables = computed<FileAiReviewsQueryVariables>(() => {
    const { search: _querySearch, ...rest } = query.value;
    return {
      ...rest,
      input: {
        file_id: fileId.value,
      },
    };
  });

  const result = useQuery({ variables });

  const data = computed(() => result.data.value?.fileAiReviews);

  return {
    data,
    fetching: result.fetching,
    error: result.error,
    refetch: () => result.executeQuery({ requestPolicy: 'network-only' }),
    query,
    setQuery,
    search,
    setSearch,
    variables,
  };
};

export default useFileAiReviewsSearch;
